/*
  Levée PDP round 2 behaviour. Added 2026-10-08 on the WORKING theme. Loaded only by templates/product.all-sandals.json
  (snippets/levee-pdp-v2.liquid). Replaces assets/levee-pdp-v1.js (round 1 pair-count rows are gone; quantity is 1 as on live).
  Round 3 (2026-10-08): the "no size preselected" handling and the custom reviews list are removed (size 36 is preselected
  and the Loox reviews widget is back, as on live; the removed code is in Git history). Each carousel card now opens that
  review in Loox's own pop-up, exactly like Loox's carousel (LOOX.openQV(review id)).
  "Over 10,000 pairs sold" carousel (snippets/levee-sold-carousel.liquid): 5-star photo reviews from the Loox
     Storefront API, this product's family first, then the Signature range. Same screen as design-inputs/loox-picks.md:
     verified, dated from 13 Aug 2025 (first real order; earlier reviews are imports), never "Natalia C.", and never text
     with health wording, "leather" or a rival brand (SOLD_EXCLUDE below). Applies to the carousel only; the Loox reviews
     widget keeps every review.
  Round 4 (2026-10-09, Round 4 checklist L1 to L4, R1 to R3):
  1. The carousel (now headed "Loved by real women") also shows 5-star VIDEO reviews from the same API calls and the same
     screen (plus a deny list in the snippet). Card 1 is the snippet's data-video-first video when it qualifies, then video
     and photo alternate until the videos run out, then the remaining photos. Phones: the card in view plays Loox's 5 s
     preview MP4 (muted, inline, looping; the Cloudflare Stream MP4 if the preview fails), one video at a time, paused when
     the carousel leaves the screen or a Loox pop-up is open. Desktop (mouse): a video card plays while hovered. Posters stay
     if the browser refuses to autoplay. media[].url (an iframe player page) is never used as a video source.
  2. Customer reviews list (snippets/levee-reviews-r4.liquid), laid out like Loox's list: every review, 5-star with media
     first, then 5-star text, 4-star with media, 4-star text ... 1-star, newest first inside each group. Falls back to the
     original Loox widget if the API fails.
  Round 5 Draft A (2026-10-09, Round 5 checklist C1 to C5 and R1; Paper page "Round 5 · LATEST (open this)"):
  1. Carousel: every qualifying store-wide 5-star media review, videos first (data-video-first, then newest first), then
     photos newest first. One API call (rating=5, featured, limit 100, daily v= stamp; page 2 only if page 1 still ends in
     media). Screen: health words as WHOLE words, "leather" only allowed as "vegan leather", rival brands, Natalia C., deny
     list. Every card shell is built at once; only the first 3 get their image straight away, the rest when they come
     within about 2 cards of the card in view (IntersectionObserver on the track). Photos use Loox's 500 px {name}.jpg
     (falls back to _mid); videos keep their poster and get their src only when their card loads (preload none).
     Sage hearts instead of the brown stars. Video behaviour unchanged from round 4.
  2. Reviews list: Loox's own controls. The arrow opens the rating breakdown (counts from /product-reviews/bottomline);
     a row filters to that star level, tapping it again clears it. The sliders button opens "Sort by": Featured (our
     order), Newest, Highest Ratings, Lowest Ratings. Filter and sort combine; 6 per page; Show more keeps both.
  Round 6b (2026-10-14, Round 6 checklist X1): "Complete the look" cards (initCompleteLook, snippets/levee-complete-look.liquid):
  colour dots switch the card's product, sizes follow the main picker, ADD TO CART adds one pair through the theme's cart
  queue and cart-update event (the drawer opens and Shopify prices it). That is the only cart write in this file.
  Round 7a (2026-10-16): some Loox review text arrives with Markdown emphasis ("**Absolutely AMAZING ...!**"), which the
  "Loved by real women" cards printed as literal asterisks. displayText() drops paired emphasis marks for display only.
  Round 7b (2026-10-16, Paper "Round 7 · LATEST (open this)", Draft E): imported or templated reviews never become carousel
  cards (dated before 30 Oct 2025, Levée's first genuine review, or text repeated word for word under another name; research
  33 section 7), and "Complete the look" uses one native size menu per card ("Choose size" until she picks a size in the buy
  box; ADD TO CART with no size opens the menu).
  Text from reviews is only ever set with textContent. Nothing here changes prices.
*/
(function () {
  'use strict';

  var API = 'https://storefront-api.loox.io/storefront/v1/store/';
  // Carousel-only screen (curated showcase). Round 5: health words as WHOLE words (so "secure" no longer trips "cure"),
  // rival brands as before, and "leather" only allowed in "vegan leather" (checked separately below).
  var SOLD_HEALTH = /\b(?:heal|healed|healing|relief|pain|painful|sore|ache|aches|aching|hurt|hurts|plantar|fasciitis|bunion|bunions|arthritis|orthotic|podiatrist|neuropathy|surgery|injury|cure|cured)\b/i;
  var SOLD_RIVAL = /birkenstock|birks|brooks|kumi|ziera|frankie4|vionic|skechers|slyde|oofos|crocs/i;
  // Round 7b (2026-10-16, research 33 section 7): imported or templated reviews never show in the carousel. They are dated
  // 21 Feb 2024 to 4 Aug 2025, before Levée's first genuine review on 30 Oct 2025 (was: from 13 Aug 2025, the first order).
  var SOLD_FROM = Date.parse('2025-10-30T00:00:00+10:00');
  // Outline heart (Loox's empty star): the filled heart plus an inner cut-out, drawn with fill-rule evenodd.
  var HEART_OUTLINE = 'M17.4.9c3.646 0 6.6 3 6.6 7.2 0 8.4-9 13.2-12 15-3-1.8-12-6.6-12-15C0 3.9 3 .9 6.6.9c2.232 0 4.2 1.2 5.4 2.4C13.2 2.1 15.168.9 17.4.9Zm-4.28 18.725a32.344 32.344 0 0 0 2.905-2.041C19.602 14.74 21.6 11.632 21.6 8.1c0-2.832-1.844-4.8-4.2-4.8-1.291 0-2.688.684-3.703 1.697L12 6.694l-1.697-1.697C9.288 3.984 7.891 3.3 6.6 3.3c-2.328 0-4.2 1.987-4.2 4.8 0 3.533 2 6.64 5.574 9.484a32.29 32.29 0 0 0 2.905 2.04c.359.226.714.444 1.121.686.407-.242.762-.46 1.12-.685Z';
  // Loox's own 5 s preview clip (what Loox's carousel loops): uploads/video-preview/{Y}/{M}/{D}/{streamUid}_mid.mp4,
  // date = the review's date (UTC), no zero padding. Fallback: the full clip as an MP4 from Cloudflare Stream.
  var VIDEO_PREVIEW = 'https://images.loox.io/uploads/video-preview/';
  var VIDEO_STREAM = 'https://videodelivery.net/';
  var SVGNS = 'http://www.w3.org/2000/svg';
  // Round 8a (Round 8 checklist U13, research 43 section 5): Loox product id (review.product.id) to style and colour, read
  // from Loox on 17 Oct 2026 (old Sienne listings included). Signature reviews with no colour count for all three colours.
  var LOOX_PRODUCTS = {
    '8979903086846': ['signature', 'Dune'], '8958943166718': ['signature', 'Dune'], '9131324834046': ['signature', 'Dune'], '9180504129790': ['signature', 'Dune'],
    '8981440299262': ['signature', 'Black'], '8959335366910': ['signature', 'Black'], '9131324997886': ['signature', 'Black'],
    '8981440233726': ['signature', 'White'], '8959223693566': ['signature', 'White'], '9131324866814': ['signature', 'White'],
    '8974589231358': ['signature', ''], '8979886833918': ['signature', ''], '8979903906046': ['signature', ''],
    '9138674368766': ['buckled', 'Brown'], '9138675286270': ['buckled', 'Black'],
    '9138673352958': ['double-strap', 'Greige'], '9138673582334': ['double-strap', 'Brown'], '9138673811710': ['double-strap', 'Black'],
    '9138668241150': ['denim', 'Khaki'], '9138669388030': ['denim', 'Black'], '9138669486334': ['denim', 'Blue']
  };
  var STYLE_NAMES = { 'signature': 'Signature', 'buckled': 'Buckled Signature', 'double-strap': 'Double Strap', 'denim': 'Denim' };
  var NEAREST_STYLE = { 'denim': 'double-strap', 'double-strap': 'buckled', 'buckled': 'signature', 'signature': 'buckled' };
  var PER_PRODUCT_FILL = 16;
  var PER_PRODUCT_MAX = 24;
  var HEART = 'M17.4.9c3.646 0 6.6 3 6.6 7.2 0 8.4-9 13.2-12 15-3-1.8-12-6.6-12-15C0 3.9 3 .9 6.6.9c2.232 0 4.2 1.2 5.4 2.4C13.2 2.1 15.168.9 17.4.9Z';

  /* ---------- helpers ---------- */
  function api(storeId, params, path) {
    var url = new URL(API + encodeURIComponent(storeId) + (path || '/product-reviews'));
    Object.keys(params).forEach(function (k) { url.searchParams.set(k, params[k]); });
    return fetch(url.toString(), { mode: 'cors', credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('Loox Storefront API ' + r.status);
      return r.json();
    });
  }
  function make(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }
  // Round 7a: review text for display. Loox keeps Markdown emphasis as typed (e.g. "**10/10 for the shoes!**"); drop paired
  // marks (***x***, **x**, __x__, *x*, _x_) so the card shows the words, not the asterisks. The words themselves never change,
  // a run of stars ("*****") or "5*" stays, an unpaired mark stays, and the carousel screen still reads the raw text.
  // No lookbehind (older iPhone Safari can't parse it). Same rules as scripts/loox_carousel_screen.py display_text().
  function displayText(s) {
    return String(s || '')
      .replace(/(^|[^*_])(\*\*\*|___|\*\*|__)(?=[^\s*_])([\s\S]*?[^\s*_])\2(?![*_])/g, '$1$3')
      .replace(/(^|[\s(\["'\u201c\u2018])([*_])(?=[^\s*_])([^*_\n]*?[^\s*_])\2(?=$|[\s)\]"'\u201d\u2019.,!?;:])/g, '$1$3')
      .trim();
  }
  function photoOf(r) {
    var list = Array.isArray(r && r.media) ? r.media : [];
    for (var i = 0; i < list.length; i++) if (list[i] && list[i].type === 'photo' && list[i].url) return list[i];
    return null;
  }
  function videoOf(r) {
    var list = Array.isArray(r && r.media) ? r.media : [];
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (m && m.type === 'video' && m.thumbnailUrl && streamUid(m.url)) return m;
    }
    return null;
  }
  function streamUid(url) {
    var m = /videodelivery\.net\/([0-9a-f]{32})/i.exec(url || '');
    return m ? m[1] : null;
  }
  function previewUrl(r, uid) {
    var d = new Date(r.date || r.createdAt);
    if (isNaN(d)) return null;
    return VIDEO_PREVIEW + d.getUTCFullYear() + '/' + (d.getUTCMonth() + 1) + '/' + d.getUTCDate() + '/' + uid + '_mid.mp4';
  }
  // Loox serves a ~130 KB "_mid" rendition next to each "_orig" upload; use it for on-page photos.
  function mid(url) {
    return /images\.loox\.io\//.test(url) ? url.replace(/_orig(\.[a-z]+)$/i, '_mid$1') : url;
  }
  // Round 5 (C4): Loox's own widget image, {name}.jpg, 500 px on the long edge (~32 KB), for the carousel cards.
  function plain(url) {
    return /images\.loox\.io\//.test(url) ? url.replace(/_orig(\.[a-z]+)$/i, '$1') : url;
  }
  // Daily cache stamp (Brisbane date). Loox's API ignores unknown parameters; this only makes a fresh edge-cache entry once
  // a day, so new reviews show within a day instead of up to 7 (the API sends s-maxage=604800).
  function dayStamp() {
    return new Date(Date.now() + 10 * 3600 * 1000).toISOString().slice(0, 10).replace(/-/g, '');
  }
  function whenNear(node, margin, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); cb(); }
    }, { rootMargin: margin + ' 0px' });
    io.observe(node);
  }
  function svg(viewBox, inner, cls) {
    var s = document.createElementNS(SVGNS, 'svg');
    s.setAttribute('viewBox', viewBox);
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    if (cls) s.setAttribute('class', cls);
    s.innerHTML = inner;
    return s;
  }
  function openQV(id) {
    if (window.LOOX && typeof window.LOOX.openQV === 'function') {
      try { window.LOOX.openQV(id); return true; } catch (e) {}
    }
    return false;
  }
  function qvOpen() {
    var f = document.querySelector('iframe[src*="/post/quickview/"]');
    if (!f) return false;
    var r = f.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  /* ---------- Loved by real women (carousel) ---------- */
  function initSold(root) {
    if (root.dataset.lvReady) return;
    root.dataset.lvReady = '1';
    var storeId = root.dataset.storeId;
    var track = root.querySelector('[data-lv-sold-track]');
    if (!storeId || !track) return;
    var deny = (root.dataset.videoDeny || '').split(',').filter(Boolean);
    var firstVideo = root.dataset.videoFirst || '';
    var posters = {}, focus = {};
    try { posters = JSON.parse(root.dataset.videoPosters || '{}') || {}; } catch (e) { posters = {}; }
    try { focus = JSON.parse(root.dataset.mediaFocus || '{}') || {}; } catch (e) { focus = {}; }

    // Round 5 screen (C3): verified 5-star, not Natalia C., dated from 30 Oct 2025 (round 7b; was 13 Aug 2025), not denied,
    // no health words (whole words), no rival brand, and "leather" only as "vegan leather".
    function screened(r) {
      if (!r || r.rating !== 5 || r.verified !== true) return false;
      if (deny.indexOf(r.id) !== -1) return false;
      var body = (r.body || '').trim();
      var name = (r.reviewer && r.reviewer.name || '').trim();
      if (!body || !displayText(body) || !name) return false;
      if (name.toLowerCase() === 'natalia c.') return false;
      if (SOLD_HEALTH.test(body) || SOLD_RIVAL.test(body)) return false;
      if (/leather/i.test(body.replace(/vegan[\s-]+leather/gi, ''))) return false;
      var when = Date.parse(r.date || r.createdAt);
      if (!(when >= SOLD_FROM)) return false;
      return true;
    }

    function heartsRow() {
      var stars = make('span', 'lv-sold__stars');
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', '5 out of 5 stars');
      for (var h = 0; h < 5; h++) stars.appendChild(svg('0 0 24 24', '<path d="' + HEART + '"/>'));
      return stars;
    }

    // Round 5 (C4): a card is built as a shell (text, hearts, empty media box); hydrate() gives it its image (and, for a
    // video card, its video source) when it comes near the view.
    function hydrate(entry) {
      if (!entry || entry.hydrated) return;
      entry.hydrated = true;
      var img = entry.img;
      if (entry.video) {
        img.src = entry.poster;
        entry.video.src = entry.videoSrc;
      } else {
        img.addEventListener('error', function onErr() {
          img.removeEventListener('error', onErr);
          if (entry.fallbackSrc && img.getAttribute('src') !== entry.fallbackSrc) img.src = entry.fallbackSrc;
        });
        img.src = entry.src;
      }
      entry.box.insertBefore(img, entry.box.firstChild);
      entry.el.classList.add('is-loaded');
    }

    function card(r, i, isVideo) {
      var fig = make('figure', 'lv-sold__card' + (isVideo ? ' lv-sold__card--video' : ''));
      fig.setAttribute('role', 'listitem');
      var name = r.reviewer.name.trim();
      var box = make('div', 'lv-sold__media');
      var img = make('img', 'lv-sold__photo');
      var entry = { el: fig, review: r, video: null, img: img, box: box, hydrated: false };
      if (focus[r.id]) img.style.objectPosition = focus[r.id];
      if (isVideo) {
        var v = videoOf(r);
        var uid = streamUid(v.url);
        entry.poster = posters[r.id] || v.thumbnailUrl;
        img.alt = 'Video from ' + name + "'s review";
        var video = document.createElement('video');
        video.className = 'lv-sold__video';
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.loop = true;
        video.setAttribute('loop', '');
        video.preload = 'none';
        video.setAttribute('preload', 'none');
        video.setAttribute('aria-hidden', 'true');
        video.setAttribute('tabindex', '-1');
        video.setAttribute('disablepictureinpicture', '');
        video.setAttribute('disableremoteplayback', '');
        if (focus[r.id]) video.style.objectPosition = focus[r.id];
        var fallback = VIDEO_STREAM + uid + '/downloads/default.mp4';
        entry.videoSrc = previewUrl(r, uid) || fallback; // set by hydrate(), so far-away cards fetch nothing
        video.addEventListener('error', function () {
          if (!video.getAttribute('src')) return;
          if (video.dataset.lvFallback || video.getAttribute('src') === fallback) return;
          video.dataset.lvFallback = '1';
          var wasWanted = fig.classList.contains('is-wanted');
          video.src = fallback;
          if (wasWanted) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        });
        video.addEventListener('playing', function () { fig.classList.add('is-playing'); fig.removeAttribute('data-autoplay'); });
        video.addEventListener('pause', function () { fig.classList.remove('is-playing'); });
        entry.video = video;
        box.appendChild(video);
        var badge = make('span', 'lv-sold__muted');
        badge.setAttribute('aria-hidden', 'true');
        badge.appendChild(svg('0 0 24 24', '<path d="M11 5L6 9H2v6h4l5 4z" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M23 9l-6 6M17 9l6 6" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'));
        box.appendChild(badge);
      } else {
        var photoUrl = photoOf(r).url;
        entry.src = plain(photoUrl);
        entry.fallbackSrc = mid(photoUrl);
        img.alt = 'Photo from ' + name + "'s review";
      }
      img.width = 236;
      img.height = 295;
      img.decoding = 'async';
      fig.appendChild(box);
      // Round 5 (C5): five sage hearts (Paper Draft A: 14 px, 2 px apart, #9A9F8C) instead of the brown stars.
      fig.appendChild(heartsRow());
      fig.appendChild(make('blockquote', 'lv-sold__quote', '"' + displayText(r.body) + '"'));
      var cap = make('figcaption', 'lv-sold__name', name);
      // Round 8a: a card borrowed from another product says which one ("in Signature, Dune"); the page's own cards show
      // the name only.
      if (r.lvFrom) cap.appendChild(make('span', 'lv-sold__from', 'in ' + r.lvFrom));
      fig.appendChild(cap);
      // Round 3 (S2): tap anywhere on the card to open this review in Loox's own pop-up, the same call Loox's carousel makes.
      var open = make('button', 'lv-sold__open');
      open.type = 'button';
      open.setAttribute('aria-label', (isVideo ? 'Watch ' : 'Read ') + name + "'s review");
      open.addEventListener('click', function () {
        if (openQV(r.id)) player.quickView();
      });
      fig.appendChild(open);
      return entry;
    }

    /* Plays the card in view (touch) or the hovered card (mouse); one video at a time. */
    var player = (function () {
      var cards = [], videos = [];
      var state = { active: -1, inView: false, hover: null, lastHover: null, qv: false };
      var hoverMode = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
      var settle = null, qvTimer = null;

      function current() { return hoverMode ? state.hover : (state.active >= 0 ? cards[state.active] : null); }
      function update() {
        var cur = current();
        var allowed = !state.qv && document.visibilityState !== 'hidden' && (hoverMode || state.inView);
        var target = allowed && cur && cur.video ? cur : null;
        var keep = hoverMode ? state.lastHover : cur; // paused but not rewound (resumes where it was)
        videos.forEach(function (c) {
          c.el.classList.toggle('is-wanted', c === target);
          if (c === target) return;
          if (!c.video.paused) c.video.pause();
          if (c !== keep && c.video.currentTime > 0) { try { c.video.currentTime = 0; } catch (e) {} }
        });
        // The video cards either side of the card in view get preload="metadata" so the next one starts quickly.
        // Round 5 (C4): only once the carousel is actually on screen, so a page view that never reaches the carousel
        // downloads no clip (Chrome's "metadata" preload fetches most of a 0.2 to 1.2 MB preview clip).
        if (!hoverMode && state.active >= 0 && state.inView) {
          var prev = null, next = null;
          for (var i = state.active - 1; i >= 0 && !prev; i--) if (cards[i].video) prev = cards[i];
          for (var j = state.active + 1; j < cards.length && !next; j++) if (cards[j].video) next = cards[j];
          [prev, next].forEach(function (n) {
            if (n && n.video.preload === 'none') { n.video.preload = 'metadata'; n.video.setAttribute('preload', 'metadata'); }
          });
        }
        if (target && target.video.paused) {
          hydrate(target); // round 5: a card swiped into view before its lazy load still plays
          var p;
          try { p = target.video.play(); } catch (e) { target.el.setAttribute('data-autoplay', 'blocked'); return; }
          if (p && p.catch) p.catch(function () { target.el.setAttribute('data-autoplay', 'blocked'); });
        }
      }
      // The card in view = the card with the largest visible share of its width inside the row (the left one on ties).
      function computeActive() {
        var tr = track.getBoundingClientRect();
        var best = -1, bestRatio = 0;
        cards.forEach(function (c, i) {
          var r = c.el.getBoundingClientRect();
          if (!r.width) return;
          var ratio = (Math.min(r.right, tr.right) - Math.max(r.left, tr.left)) / r.width;
          if (ratio > bestRatio + 0.01) { bestRatio = ratio; best = i; }
        });
        return best;
      }
      function onSettle() {
        clearTimeout(settle);
        state.active = computeActive();
        update();
      }
      function start(list) {
        cards = list;
        videos = list.filter(function (c) { return c.video; });
        if (!videos.length) return;
        track.addEventListener('scroll', function () {
          clearTimeout(settle);
          settle = setTimeout(onSettle, 140);
        }, { passive: true });
        if ('onscrollend' in window) track.addEventListener('scrollend', onSettle);
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { state.inView = en.isIntersecting && en.intersectionRatio >= 0.5; });
            update();
          }, { threshold: [0, 0.25, 0.5, 0.75, 1] }).observe(track);
        } else {
          state.inView = true;
        }
        videos.forEach(function (c) {
          c.el.addEventListener('mouseenter', function () { if (!hoverMode) return; state.hover = c; state.lastHover = c; update(); });
          c.el.addEventListener('mouseleave', function () { if (!hoverMode) return; if (state.hover === c) state.hover = null; update(); });
        });
        document.addEventListener('visibilitychange', update);
        window.addEventListener('resize', function () { clearTimeout(settle); settle = setTimeout(onSettle, 200); }, { passive: true });
        state.active = computeActive();
        update();
      }
      // A Loox pop-up plays the full clip itself, so the carousel pauses until it closes.
      function quickView() {
        state.qv = true;
        update();
        var seen = false, t0 = Date.now();
        clearInterval(qvTimer);
        qvTimer = setInterval(function () {
          var open = qvOpen();
          if (open) seen = true;
          if ((seen && !open) || (!seen && Date.now() - t0 > 4000)) {
            clearInterval(qvTimer);
            state.qv = false;
            update();
          }
        }, 400);
      }
      return { start: start, quickView: quickView, state: state };
    })();
    root.lvPlayer = player;

    // Round 5 (C2 to C4): one store-wide call, 5-star in Loox's featured order (photo and video reviews lead, so every
    // media review sits in the first 100 today). If page 1 still ends with a media review, the next page is read too, so
    // the carousel stays unlimited. The daily stamp lets new reviews in within a day; the call is edge-cached otherwise.
    // Round 8a (Round 8 checklist U13, research 43 section 5): on a product page, (1) this colour, (2) the same style in
    // its other colours, (3) the nearest style, (4) everything else; each step keeps the order above (videos first,
    // then photos, newest first). Every card of the page's own style shows; steps 3 and 4 fill up to 16; 24 at most.
    function perProduct(list) {
      var own = LOOX_PRODUCTS[root.dataset.productId] || [root.dataset.lvStyle || '', root.dataset.lvColour || ''];
      var style = own[0], colour = own[1];
      if (!style) return list;
      var near = NEAREST_STYLE[style];
      var steps = [[], [], [], []];
      list.forEach(function (o) {
        var m = LOOX_PRODUCTS[String(o.r.product && o.r.product.id || '')];
        var step = 3;
        if (m && m[0] === style && (m[1] === colour || (style === 'signature' && !m[1]))) step = 0;
        else if (m && m[0] === style) step = 1;
        else if (m && m[0] === near) step = 2;
        o.r.lvFrom = step === 0 ? '' : (m ? STYLE_NAMES[m[0]] + (m[1] ? ', ' + m[1] : '') : '');
        steps[step].push(o);
      });
      var ownStyle = steps[0].concat(steps[1]);
      var want = Math.min(PER_PRODUCT_MAX, Math.max(PER_PRODUCT_FILL, ownStyle.length));
      return ownStyle.concat(steps[2], steps[3]).slice(0, want);
    }
    var stamp = dayStamp();
    function readAll(page, acc) {
      var params = { rating: 5, sort: 'featured', limit: 100 };
      if (page > 1) params.page = page;
      params.v = stamp;
      return api(storeId, params).then(function (d) {
        var list = (d && d.reviews) || [];
        acc = acc.concat(list);
        var last = list[list.length - 1];
        var more = d && d.pagination && d.pagination.hasMore;
        if (more && last && Array.isArray(last.media) && last.media.length && page < 20) return readAll(page + 1, acc);
        return acc;
      });
    }
    readAll(1, []).then(function (reviews) {
      // Round 7b: a review whose text repeats word for word under another reviewer's name is templated: never a card.
      // Compared across the reviews fetched here (scripts/loox_carousel_screen.py also checks every review store-wide and
      // any card it drops only for that goes in data-video-deny).
      var byText = {}, repeated = {};
      reviews.forEach(function (r) {
        var t = r && String(r.body || '').trim().toLowerCase().replace(/\s+/g, ' ');
        if (!t) return;
        var nm = String(r.reviewer && r.reviewer.name || '').trim().toLowerCase().replace(/\s+/g, ' ');
        (byText[t] = byText[t] || []).push({ id: r.id, name: nm });
      });
      Object.keys(byText).forEach(function (t) {
        var g = byText[t], names = {};
        g.forEach(function (x) { names[x.name] = 1; });
        if (Object.keys(names).length > 1) g.forEach(function (x) { repeated[x.id] = 1; });
      });
      var seen = {}, photos = [], videos = [];
      reviews.forEach(function (r) {
        if (!r || seen[r.id] || repeated[r.id] || !screened(r)) return;
        if (videoOf(r)) { seen[r.id] = true; videos.push(r); return; }
        if (photoOf(r)) { seen[r.id] = true; photos.push(r); }
      });
      // Videos first: the chosen video, then the other videos newest first; then the photos newest first.
      videos.sort(byNewest);
      photos.sort(byNewest);
      for (var k = 0; k < videos.length; k++) {
        if (videos[k].id === firstVideo) { videos.unshift(videos.splice(k, 1)[0]); break; }
      }
      var order = videos.map(function (r) { return { r: r, v: true }; }).concat(photos.map(function (r) { return { r: r, v: false }; }));
      if (root.dataset.productId) order = perProduct(order);
      if (order.length < 2) { root.hidden = true; return; }
      track.textContent = '';
      var entries = order.map(function (o, i) { var e = card(o.r, i, o.v); track.appendChild(e.el); return e; });
      root.setAttribute('data-lv-count', String(order.length));
      root.setAttribute('data-lv-videos', String(videos.length));
      // Images: the first 3 cards straight away; every other card when it comes within about 2 cards of the card in
      // view (root margin 64% of the row's width: card 3 at 360 to 414 px stays out until the first swipe).
      entries.slice(0, 3).forEach(hydrate);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (list) {
          list.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.unobserve(en.target);
            hydrate(en.target.lvEntry);
          });
        }, { root: track, rootMargin: '0px 64% 0px 64%', threshold: 0 });
        entries.slice(3).forEach(function (e) { e.el.lvEntry = e; io.observe(e.el); });
      } else {
        entries.forEach(hydrate);
      }
      player.start(entries);
    }).catch(function () { root.hidden = true; });
  }

  /* ---------- Customer reviews list (Loox card format) ---------- */
  function hearts(rating, cls) {
    var wrap = make('span', cls);
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', rating + ' out of 5 stars');
    for (var i = 1; i <= 5; i++) {
      wrap.appendChild(svg('0 0 24 24', '<path d="' + HEART + '"/>', i > rating ? 'is-empty' : ''));
    }
    return wrap;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ddmmyyyy(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear();
  }
  function hasMedia(r) {
    return !!(photoOf(r) || videoOf(r));
  }
  function ts(r) { return Date.parse(r.date || r.createdAt) || 0; }
  function byNewest(a, b) { return ts(b) - ts(a); }

  // Round 5 (R1): the sort options of Loox's own "Sort by" menu, mapped to the Loox Storefront API (research 16 section 3).
  // Featured keeps our order (5-star with media, 5-star text, 4-star with media ... 1-star text).
  var SORTS = [
    { key: 'featured', label: 'Featured', params: null },
    { key: 'newest', label: 'Newest', params: { sort: 'date', direction: 'desc' } },
    { key: 'highest', label: 'Highest Ratings', params: { sort: 'rating', direction: 'desc' } },
    { key: 'lowest', label: 'Lowest Ratings', params: { sort: 'rating', direction: 'asc' } }
  ];
  var TICK = '<path d="M6.364 9.28895L15.556 0.0959473L16.971 1.50995L6.364 12.1169L0 5.75295L1.414 4.33895L6.364 9.28895Z"/>';

  function initReviews(root) {
    if (root.dataset.lvReady) return;
    root.dataset.lvReady = '1';
    var storeId = root.dataset.storeId;
    var productId = root.dataset.productId;
    var clientId = root.dataset.clientId;
    var list = root.querySelector('[data-lv-rl-list]');
    var more = root.querySelector('[data-lv-rl-more]');
    var countEl = root.querySelector('[data-lv-rl-count]');
    var write = root.querySelector('[data-lv-rl-write]');
    var toggle = root.querySelector('[data-lv-rl-toggle]');
    var bd = root.querySelector('[data-lv-rl-breakdown]');
    var sortBtn = root.querySelector('[data-lv-rl-sort]');
    var menu = root.querySelector('[data-lv-rl-menu]');
    var STEP = 6, LIMIT = 100;
    var state = { sort: 'featured', rating: 0, chosen: false };
    var source = null, gen = 0, shown = 0;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    if (write) {
      write.addEventListener('click', function (e) {
        if (window.LOOX && typeof window.LOOX.showReviewForm === 'function') {
          e.preventDefault();
          try { window.LOOX.showReviewForm(productId); } catch (err) { window.open(write.href, '_blank', 'noopener'); }
        }
      });
    }

    // Featured (our order) for the given star levels. Each star level is read in Loox's "featured" order (pinned, then
    // photo/video newest first, then text newest first) and re-ordered here: media newest first, then text newest first.
    // A text review is only shown once every review newer than it at that star level has been loaded, so a pinned one
    // never jumps the queue. Unchanged from round 4 apart from taking the star levels as a list (one level when filtered).
    function featuredSource(levels) {
      var tiers = levels.map(function (n) { return { rating: n, page: 1, done: false, loaded: [], ids: {}, out: {}, phase: 'media' }; });
      var cur = 0, ready = [], pending = null;
      function load(t) {
        if (pending) return pending;
        pending = api(storeId, { rating: t.rating, sort: 'featured', limit: LIMIT, page: t.page }).then(function (d) {
          (d.reviews || []).forEach(function (r) { if (r && !t.ids[r.id]) { t.ids[r.id] = true; t.loaded.push(r); } });
          if (d.pagination && d.pagination.hasMore) t.page += 1; else t.done = true;
          pending = null;
        }, function (err) { pending = null; throw err; });
        return pending;
      }
      function drain(t) {
        if (t.phase === 'media') {
          var last = t.loaded[t.loaded.length - 1];
          if (!t.done && (!last || hasMedia(last))) return; // featured order may still hold more photo/video reviews
          t.loaded.filter(hasMedia).sort(byNewest).forEach(function (r) { t.out[r.id] = true; ready.push(r); });
          t.phase = 'text';
        }
        if (t.phase === 'text') {
          var boundary = t.done ? -Infinity : ts(t.loaded[t.loaded.length - 1]);
          t.loaded.filter(function (r) { return !t.out[r.id] && ts(r) >= boundary; }).sort(byNewest)
            .forEach(function (r) { t.out[r.id] = true; ready.push(r); });
          if (t.done) t.phase = 'end';
        }
      }
      function fill(n) {
        while (cur < tiers.length && ready.length < n) {
          var t = tiers[cur];
          drain(t);
          if (ready.length >= n) break;
          if (t.phase === 'end') { cur += 1; continue; }
          return load(t).then(function () { return fill(n); });
        }
        return Promise.resolve();
      }
      return {
        next: function (n) { return fill(n).then(function () { return ready.splice(0, n); }); },
        done: function () { return cur >= tiers.length && ready.length === 0; },
        prefetch: function (n) { fill(n).catch(function () {}); }
      };
    }
    // Newest / Highest / Lowest: Loox's own sort, 6 a page (page size of the Loox widget), optionally one star level.
    function apiSource(params, rating) {
      var page = 1, done = false, total = 0;
      return {
        next: function (n) {
          var q = {};
          Object.keys(params).forEach(function (k) { q[k] = params[k]; });
          if (rating) q.rating = rating;
          q.limit = n;
          q.page = page;
          if (total) q.total = total;
          return api(storeId, q).then(function (d) {
            page += 1;
            total = (d.pagination && d.pagination.total) || total;
            done = !(d.pagination && d.pagination.hasMore);
            return d.reviews || [];
          });
        },
        done: function () { return done; }
      };
    }
    function makeSource() {
      var s = SORTS.filter(function (x) { return x.key === state.sort; })[0] || SORTS[0];
      if (!s.params) return featuredSource(state.rating ? [state.rating] : [5, 4, 3, 2, 1]);
      return apiSource(s.params, state.rating);
    }
    function cardFor(r) {
      var li = make('li', 'lv-rl__card');
      li.setAttribute('data-rating', String(r.rating));
      var name = (r.reviewer && r.reviewer.name || 'Customer').trim();
      var text = make('div', 'lv-rl__text');
      var row = make('div', 'lv-rl__name-row');
      row.appendChild(make('span', 'lv-rl__name', name));
      if (r.verified) {
        var v = make('span', 'lv-rl__verified');
        v.appendChild(svg('0 0 24 24', '<path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>'));
        v.appendChild(document.createTextNode('Verified'));
        row.appendChild(v);
      }
      text.appendChild(row);
      var date = ddmmyyyy(r.date || r.createdAt);
      if (date) text.appendChild(make('span', 'lv-rl__date', date));
      text.appendChild(hearts(r.rating, 'lv-rl__hearts lv-rl__hearts--card'));
      if (r.body) text.appendChild(make('p', 'lv-rl__body', r.body.trim()));
      li.appendChild(text);
      var photo = photoOf(r), video = videoOf(r);
      var mediaUrl = null;
      if (photo || video) {
        li.setAttribute('data-media', video && !photo ? 'video' : 'photo');
        var box = make('span', 'lv-rl__media');
        var img = make('img');
        img.src = photo ? mid(photo.url) : video.thumbnailUrl;
        img.alt = (photo ? 'Photo from ' : 'Video from ') + name + "'s review";
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 94;
        img.height = 126;
        box.appendChild(img);
        if (video && !photo) {
          var play = make('span', 'lv-rl__play');
          play.appendChild(svg('0 0 24 24', '<path d="M9 7l8 5-8 5z" fill="#fff"/>'));
          box.appendChild(play);
        }
        li.appendChild(box);
        mediaUrl = photo ? photo.url : video.url;
      } else {
        li.setAttribute('data-media', 'none');
      }
      // The whole card opens Loox's own pop-up, as on Loox's list.
      var open = make('button', 'lv-rl__open');
      open.type = 'button';
      open.setAttribute('aria-label', 'Open ' + name + "'s review");
      open.addEventListener('click', function () {
        if (!openQV(r.id) && mediaUrl) window.open(mediaUrl, '_blank', 'noopener');
      });
      li.appendChild(open);
      return li;
    }

    function render() {
      var g = gen, src = source;
      return src.next(STEP).then(function (items) {
        if (g !== gen) return;
        items.forEach(function (r) { list.appendChild(cardFor(r)); shown += 1; });
        root.setAttribute('data-lv-shown', String(shown));
        more.hidden = src.done();
        if (!more.hidden && src.prefetch) src.prefetch(STEP); // prefetch the next step quietly
      }, function (err) {
        if (g !== gen) return;
        if (shown) more.hidden = false; // Show more retries the same page
        throw err;
      });
    }
    // A sort or filter change reloads the list from page 1 (6 reviews), as Loox's widget does.
    function reload() {
      gen += 1;
      shown = 0;
      list.textContent = '';
      more.hidden = true;
      root.setAttribute('data-lv-sort', state.sort);
      root.setAttribute('data-lv-rating', String(state.rating || ''));
      source = makeSource();
      return render().catch(function () { more.hidden = false; });
    }
    function fallback() {
      // Back to the original Loox widget (same attributes the Loox app block renders); Loox's loader checks every second
      // for an un-upgraded #looxReviews and builds its iframe.
      var attrs = ['data-lv-rl', 'data-lv-ready', 'data-lv-shown', 'data-store-id', 'data-client-id'];
      attrs.forEach(function (a) { root.removeAttribute(a); });
      root.className = 'loox-widget';
      root.textContent = '';
      root.setAttribute('data-limit', '6');
      root.setAttribute('data-loox-aggregate', '');
      root.setAttribute('data-product-thumbnails', 'false');
      root.setAttribute('data-product-id', productId);
      root.setAttribute('data-reviews-to-display', '');
      root.setAttribute('data-default-tab', 'automatic');
      root.style.margin = '0px auto';
      root.style.maxWidth = '1080px';
      root.removeAttribute('data-upgraded');
      root.setAttribute('data-lv-fallback', clientId || '1');
    }

    /* Round 5 (R1): rating breakdown (the arrow next to the count). Inline box on phones, floating on desktop, as Loox. */
    var dist = null, total = 0;
    function showCount(n) {
      if (!countEl) return;
      if (n) { countEl.textContent = n.toLocaleString('en-AU') + ' Reviews'; root.setAttribute('data-lv-total', String(n)); }
      else if (!countEl.textContent) countEl.textContent = 'Reviews';
    }
    function heartIcons(filled, cls) {
      var wrap = make('span', cls);
      wrap.setAttribute('aria-hidden', 'true');
      for (var i = 1; i <= 5; i++) {
        wrap.appendChild(i <= filled ? svg('0 0 24 24', '<path d="' + HEART + '"/>') : svg('0 0 24 24', '<path fill-rule="evenodd" clip-rule="evenodd" d="' + HEART_OUTLINE + '"/>'));
      }
      return wrap;
    }
    function buildBreakdown(avg) {
      var box = make('div', 'lv-rl__bd-box');
      var head = make('div', 'lv-rl__bd-avg');
      head.appendChild(svg('0 0 24 24', '<path d="' + HEART + '"/>'));
      head.appendChild(make('span', 'lv-rl__bd-avg-num', (Math.round(avg * 10) / 10).toFixed(1)));
      head.setAttribute('aria-label', 'Average rating ' + (Math.round(avg * 10) / 10).toFixed(1) + ' out of 5');
      head.setAttribute('role', 'img');
      box.appendChild(head);
      [5, 4, 3, 2, 1].forEach(function (n) {
        var c = Number(dist[n] || dist[String(n)] || 0);
        var row = make('button', 'lv-rl__bd-row');
        row.type = 'button';
        row.setAttribute('data-rating', String(n));
        row.setAttribute('aria-pressed', 'false');
        row.setAttribute('aria-label', 'Filter by ' + n + (n === 1 ? ' star, ' : ' stars, ') + c.toLocaleString('en-AU') + (c === 1 ? ' review' : ' reviews'));
        row.appendChild(heartIcons(n, 'lv-rl__bd-hearts'));
        var bar = make('span', 'lv-rl__bd-bar');
        bar.setAttribute('aria-hidden', 'true');
        var trackEl = make('span', 'lv-rl__bd-track');
        var fill = make('span', 'lv-rl__bd-fill');
        fill.style.width = (total ? (c / total) * 100 : 0).toFixed(2) + '%';
        trackEl.appendChild(fill);
        bar.appendChild(trackEl);
        row.appendChild(bar);
        var cnt = make('span', 'lv-rl__bd-count', '(' + c.toLocaleString('en-AU') + ')');
        cnt.setAttribute('aria-hidden', 'true');
        row.appendChild(cnt);
        row.addEventListener('click', function () {
          state.rating = state.rating === n ? 0 : n; // tap again to clear; the box stays open
          syncRows();
          reload();
        });
        box.appendChild(row);
      });
      bd.textContent = '';
      bd.appendChild(box);
    }
    function syncRows() {
      if (!bd) return;
      bd.querySelectorAll('.lv-rl__bd-row').forEach(function (row) {
        var on = Number(row.getAttribute('data-rating')) === state.rating;
        row.setAttribute('aria-pressed', on ? 'true' : 'false');
        row.classList.toggle('is-selected', on);
      });
    }
    var closeTimer = null;
    function setBreakdown(open) {
      if (!bd || !toggle) return;
      clearTimeout(closeTimer);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('is-bd-open', open);
      bd.classList.remove('is-opening', 'is-closing');
      if (open) {
        bd.hidden = false;
        void bd.offsetWidth; // restart the open animation
        if (!reduceMotion) bd.classList.add('is-opening');
      } else if (reduceMotion) {
        bd.hidden = true;
      } else {
        bd.classList.add('is-closing');
        closeTimer = setTimeout(function () { bd.hidden = true; bd.classList.remove('is-closing'); }, 200);
      }
    }
    if (toggle && bd) {
      toggle.addEventListener('click', function () {
        if (!dist) return;
        setBreakdown(toggle.getAttribute('aria-expanded') !== 'true');
      });
    }

    /* Round 5 (R1): "Sort by" menu (the sliders button). Floats under the button; closes on a choice, outside tap or Esc. */
    function setMenu(open) {
      if (!menu || !sortBtn) return;
      sortBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.classList.remove('is-opening');
      menu.hidden = !open;
      if (open) {
        void menu.offsetWidth;
        if (!reduceMotion) menu.classList.add('is-opening');
        document.addEventListener('pointerdown', onOutside, true);
        document.addEventListener('keydown', onKey, true);
      } else {
        document.removeEventListener('pointerdown', onOutside, true);
        document.removeEventListener('keydown', onKey, true);
      }
    }
    function onOutside(e) {
      if (menu.contains(e.target) || sortBtn.contains(e.target)) return;
      setMenu(false);
    }
    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { setMenu(false); sortBtn.focus(); }
    }
    function syncOptions() {
      if (!menu) return;
      menu.querySelectorAll('[data-sort]').forEach(function (b) {
        var on = b.getAttribute('data-sort') === state.sort;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        // As Loox: no tick shows until the shopper picks an option.
        b.classList.toggle('is-chosen', on && state.chosen);
      });
    }
    if (sortBtn && menu) {
      SORTS.forEach(function (s) {
        var b = make('button', 'lv-rl__menu-opt');
        b.type = 'button';
        b.setAttribute('data-sort', s.key);
        b.appendChild(make('span', 'lv-rl__menu-label', s.label));
        b.appendChild(svg('0 0 17 13', TICK, 'lv-rl__menu-tick'));
        b.addEventListener('click', function () {
          state.sort = s.key;
          state.chosen = true;
          syncOptions();
          setMenu(false);
          sortBtn.focus();
          reload(); // the menu closes and the list reloads from page 1, as Loox's does
        });
        menu.appendChild(b);
      });
      syncOptions();
      sortBtn.addEventListener('click', function () { setMenu(sortBtn.getAttribute('aria-expanded') !== 'true'); });
    }

    // Count and breakdown from one 116-byte call (store-wide, the same set as the list), with the daily stamp so the
    // numbers match the list within a day. If it fails, the count comes from the list call as in round 4 and the
    // breakdown arrow is hidden.
    api(storeId, { v: dayStamp() }, '/product-reviews/bottomline').then(function (d) {
      var t = d && Number(d.totalReviews);
      if (!t || !d.ratingDistribution) throw new Error('no bottomline');
      total = t;
      dist = d.ratingDistribution;
      showCount(total);
      if (bd) buildBreakdown(Number(d.averageRating) || 0);
      root.classList.add('has-breakdown');
    }).catch(function () {
      if (toggle) { toggle.disabled = true; root.classList.add('no-breakdown'); }
      api(storeId, { limit: 1 }).then(function (d) {
        showCount(d && d.pagination && d.pagination.total);
      }).catch(function () { showCount(0); });
    });

    more.addEventListener('click', function () {
      more.disabled = true;
      render().then(function () { more.disabled = false; }, function () { more.disabled = false; });
    });
    source = makeSource();
    root.setAttribute('data-lv-sort', state.sort);
    root.setAttribute('data-lv-rating', '');
    render().catch(function () { if (!shown) fallback(); });
  }

  /* ---------- Round 6b (X1): "Complete the look" (snippets/levee-complete-look.liquid) ---------- */
  // The cards arrive fully rendered by Liquid (photo, prices, colours, sizes, variant ids). This only wires them up:
  // - a colour dot switches the card to that colour's own product (photo, links, prices, variant ids) from the card's JSON;
  // - ADD TO CART posts one pair to /cart/add with the hidden line-item property _source: complete-the-look, through the
  //   theme's cart queue, then hands the response to the theme's cart-update event, exactly like the main Add to Cart does,
  //   so the drawer re-renders (pair count, Buy 2 Get 1 Free progress, Shopify's own discount) and opens.
  // Round 7b (Paper "Draft E · Complete the look · 3 states"): one native size menu per card instead of eight buttons.
  // - It reads "Choose size" until she picks a size in the buy box (a size button, or the sticky bar's menu, which moves the
  //   buy box), then follows that size live; a size she picks on a card holds until the buy box changes again. The buy box's
  //   preselected EU 36 is not copied: nothing follows until she changes it.
  // - ADD TO CART with no size opens the menu (showPicker where the browser has it, otherwise focus, which opens the wheel on
  //   an iPhone) instead of adding a 36.
  // No prices are computed here: every price and discount comes from Shopify.
  function initCompleteLook(root) {
    if (root.__lvCtl) return;
    root.__lvCtl = true;
    var setters = [];
    [].slice.call(root.querySelectorAll('[data-lv-ctl-card]')).forEach(function (card) {
      var data;
      try { data = JSON.parse(card.querySelector('[data-lv-ctl-data]').textContent); } catch (e) { return; }
      var colours = data.colours || [];
      if (!colours.length) return;
      var current = colours.filter(function (c) { return c.key === card.getAttribute('data-colour'); })[0] || colours[0];
      var size = card.getAttribute('data-size') || '';
      var img = card.querySelector('.lv-ctl__photo img');
      var links = [].slice.call(card.querySelectorAll('[data-lv-ctl-link]'));
      var colourSr = card.querySelector('[data-lv-ctl-colour]');
      var was = card.querySelector('[data-lv-ctl-was]');
      var now = card.querySelector('[data-lv-ctl-now]');
      var select = card.querySelector('[data-lv-ctl-select]');
      var pickLabel = card.querySelector('[data-lv-ctl-pick-label]');
      var add = card.querySelector('[data-lv-ctl-add]');
      var addText = card.querySelector('[data-lv-ctl-add-text]');
      var addSr = card.querySelector('[data-lv-ctl-add-sr]');
      var err = card.querySelector('.lv-ctl__error');
      var busy = false;
      if (!select || !add) return;

      function variantFor(sz) { return (current.variants || []).filter(function (v) { return v.size === sz; })[0] || null; }
      function render() {
        var vs = current.variants || [];
        var opts = [].slice.call(select.options).slice(1);
        var same = opts.length === vs.length && opts.every(function (o, i) { return o.value === vs[i].size; });
        if (!same) {
          while (select.options.length > 1) select.remove(1);
          vs.forEach(function (x) { var o = document.createElement('option'); o.value = x.size; select.appendChild(o); });
          opts = [].slice.call(select.options).slice(1);
        }
        opts.forEach(function (o, i) {
          var x = vs[i];
          o.disabled = !x.available;
          // Round 7f: the Australian size after the EU size ("39 · AU 8"); x.au comes from snippets/levee-au-size.liquid.
          var lab = x.size + (x.au ? ' · AU ' + x.au : '');
          o.textContent = x.available ? lab : lab + ' · ' + (data.soldOut || 'Sold out');
        });
        var v = size ? variantFor(size) : null;
        if (size && !v) { size = ''; }
        select.value = size;
        if (pickLabel) pickLabel.textContent = size ? (data.sizeWord || 'Size') + ' ' + size : (data.choose || 'Choose size');
        var anyIn = vs.some(function (x) { return x.available; });
        var shown = v || vs.filter(function (x) { return x.available; })[0] || vs[0] || null;
        if (was) was.textContent = (shown && shown.compare) || '';
        if (was && was.parentNode) was.parentNode.hidden = !(shown && shown.compare);
        if (now && shown) now.textContent = shown.price;
        var soldOut = size ? !(v && v.available) : !anyIn;
        if (!busy) add.disabled = soldOut;
        addText.textContent = soldOut ? (data.soldOut || 'Sold out') : (data.add || 'Add to cart');
        addSr.textContent = ': ' + data.name + ', ' + current.label + (size ? ', size ' + size : '');
        card.setAttribute('data-size', size);
      }
      function setColour(key) {
        var next = colours.filter(function (c) { return c.key === key; })[0];
        if (!next || next === current) return;
        current = next;
        card.setAttribute('data-colour', key);
        if (img && current.src) { img.srcset = current.srcset || ''; img.src = current.src; }
        links.forEach(function (a) { a.setAttribute('href', current.url); });
        if (colourSr) colourSr.textContent = ', ' + current.label;
        [].slice.call(card.querySelectorAll('.lv-ctl__dot')).forEach(function (d) { d.setAttribute('aria-pressed', d.getAttribute('data-colour') === key ? 'true' : 'false'); });
        if (err) err.hidden = true;
        render();
      }
      function openPicker() {
        if (typeof select.showPicker === 'function') {
          try { select.showPicker(); return; } catch (e) { /* not allowed here: fall back to focus */ }
        }
        select.focus();
      }
      function addToCart() {
        if (!size) { openPicker(); return; }
        var v = variantFor(size);
        if (busy || !v || !v.available) return;
        var settings = window.FoxThemeSettings || {};
        var routes = settings.routes || {};
        var body = new FormData();
        body.append('id', v.id);
        body.append('quantity', '1');
        body.append('properties[_source]', 'complete-the-look');
        var sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.getSectionsToRender) sections = sections.concat(drawer.getSectionsToRender().map(function (s) { return s.id; }));
        var mainCart = document.querySelector('cart-items');
        if (mainCart && mainCart.getSectionsToRender) sections = sections.concat(mainCart.getSectionsToRender().map(function (s) { return s.section; }));
        if (sections.length) {
          body.append('sections', sections);
          body.append('sections_url', window.location.pathname);
        }
        busy = true;
        add.disabled = true;
        add.setAttribute('aria-busy', 'true');
        if (err) err.hidden = true;
        var queue = window.FoxThemeCartMutations;
        var work = function () {
          return fetch(routes.cart_add_url || '/cart/add', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
            .then(function (r) { return r.json(); })
            .then(function (state) {
              if (state.status) throw new Error(state.description || state.message || 'This pair could not be added.');
              var ev = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
              if (window.FoxThemeEvents && state.sections) window.FoxThemeEvents.emit(ev, state);
              else window.location.assign(routes.cart_url || '/cart');
              document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: state } }));
            });
        };
        if (queue && queue.flushQuantityChanges) queue.flushQuantityChanges();
        (queue ? queue.enqueue(work) : work())
          .catch(function (e) { if (err) { err.textContent = e.message; err.hidden = false; } })
          .then(function () { busy = false; add.removeAttribute('aria-busy'); render(); });
      }
      select.addEventListener('change', function () {
        size = select.value || '';
        if (err) err.hidden = true;
        render();
      });
      card.addEventListener('click', function (e) {
        var t = e.target;
        var dot = t.closest && t.closest('.lv-ctl__dot');
        if (dot) { setColour(dot.getAttribute('data-colour')); return; }
        if (t.closest && t.closest('[data-lv-ctl-add]')) addToCart();
      });
      setters.push(function (sz) { if (sz && sz !== size) { size = sz; render(); } });
      render();
    });
    if (!setters.length) return;
    var follow = function (sz) { setters.forEach(function (fn) { fn(String(sz)); }); };
    // Her own picks in the buy box: a size button (radio change) or, after the sticky bar's menu moves the buy box, the
    // theme's variant:changed. Neither fires on page load, so the preselected EU 36 is never copied.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('product-info[id^="MainProduct-"] variant-picker')) return;
      if (t.tagName === 'SELECT') follow(t.value);
      else if (t.type === 'radio' && t.checked) follow(t.value);
    });
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && v.option1) follow(v.option1);
    });
  }

  function init() {
    document.querySelectorAll('[data-lv-sold]').forEach(function (n) { whenNear(n, '800px', function () { initSold(n); }); });
    document.querySelectorAll('[data-lv-rl]').forEach(function (n) { whenNear(n, '1200px', function () { initReviews(n); }); });
    document.querySelectorAll('[data-lv-ctl]').forEach(function (n) { initCompleteLook(n); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
